<script setup lang="ts">
import { computed, defineProps } from 'vue'

const props = defineProps({
  creditSafeValue: {
    type: String,
    required: true,
  },
})

const colorClass = computed(() => {
  switch (props.creditSafeValue) {
    case 'A':
    case 'B':
      return ['text-primary']
    case 'C':
    case 'D':
      return ['text-warning']
    case 'E':
    case 'F':
      return ['text-error']
    default:
      return 'text-gray-500'
  }
})
</script>

<template>
  <b :class="[colorClass]">{{ creditSafeValue || '/' }}</b>
</template>

<style scoped></style>
